import rappidHelpers from '@/utils/helpers/rappid'
import * as Rappid from 'rappid'

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.config.globalProperties.$joint = Rappid
    app.config.globalProperties.$rappidHelpers = rappidHelpers
  },
}
